import {Button, Dropdown, notification} from "antd";
import {DownOutlined} from "@ant-design/icons";
import {useClipboard} from "../../contexts/ClipboardContext";

export default function RowMenu({children, text})
{
    const { addText } = useClipboard();
    const renderButton = () => {
        if(text)
            return (
                <Button
                    size="small"
                    style={{
                        width: 70, 
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}
                    onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                    }}
                    onContextMenu={(e) => {
                        e.preventDefault();
                        addText(text);
                    }}
                    title={text}
                >
                    <span style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        width: '100%',
                        direction: 'rtl',
                        textAlign: 'left'
                    }}>
                        {text}
                    </span>
                </Button>
            )

        return (
            <Button onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
            }}>
                <DownOutlined />
            </Button>
        )
    }

    return (
        <Dropdown trigger={'click'} overlay={children}>
            {renderButton()}
        </Dropdown>
    )
}
